import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useWizardStore } from '../../../lib/store/wizard';
import type { DimensionKey } from '../../hub/dimensions';

/**
 * Liest/schreibt die Freitext-Felder einer Dimension (Mandant-Ebene) im
 * Wizard-Store. Die Wizard-Steps sind das Mandanten-Erfassungswerkzeug →
 * sie schreiben in `dimensionData` (der Berater bearbeitet die Berater-Ebene
 * im Cockpit-Review).
 */
export function useDimensionForm(dimension: DimensionKey) {
  const { id: caseId = 'demo' } = useParams<{ id?: string }>();
  const data = useWizardStore((s) => s.cases[caseId]?.dimensionData[dimension]);
  const lastSavedAt = useWizardStore((s) => s.cases[caseId]?.lastSavedAt) ?? null;
  const setField = useWizardStore((s) => s.setDimensionField);
  const markComplete = useWizardStore((s) => s.markDimensionComplete);
  const ensureCase = useWizardStore((s) => s.ensureCase);

  useEffect(() => {
    if (!data) ensureCase(caseId);
  }, [data, ensureCase, caseId]);

  const fields = data?.fields ?? {};
  return {
    caseId,
    fields,
    get: (key: string): string => fields[key] ?? '',
    set: (key: string, value: string): void => {
      setField(caseId, dimension, key, value);
    },
    markComplete: (): void => {
      markComplete(caseId, dimension);
    },
    lastSavedAt,
  };
}
